export const dateFormator = (dateString, format="month-day-year") => {
  if (!dateString) return "";

  const date = new Date(dateString);

  // Check if date is invalid
  if (isNaN(date.getTime())) {
    // return "df-n/a";
    return "-";
  }

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const shortMonths = months.map((month) => month.slice(0, 3));

  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const tzAbbreviations = {
    "Asia/Kolkata": "IST",
    "America/New_York": "EST/EDT",
    "America/Los_Angeles": "PST/PDT",
    "Europe/London": "GMT/BST",
    UTC: "UTC",
  };

  const shortDays = days.map((day) => day.slice(0, 3));

  const padZero = (num) => String(num).padStart(2, "0");

  const formats = {
    full: `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`,
    short: `${
      shortMonths[date.getMonth()]
    } ${date.getDate()}, ${date.getFullYear()}`,
    "date-month-year": `${padZero(date.getDate())}-${padZero(
      date.getMonth() + 1
    )}-${date.getFullYear()}`,
    "date/month/year": `${padZero(date.getDate())}/${padZero(
      date.getMonth() + 1
    )}/${date.getFullYear()}`,
    "year-month-date": `${date.getFullYear()}-${padZero(
      date.getMonth() + 1
    )}-${padZero(date.getDate())}`,
    "month-date": `${shortMonths[date.getMonth()]} ${date.getDate()}`,
    time: `${padZero(date.getHours())}:${padZero(date.getMinutes())}`,
    "time-ampm": `${padZero(date.getHours() % 12 || 12)}:${padZero(
      date.getMinutes()
    )} ${date.getHours() >= 12 ? "PM" : "AM"}`,
    datetime: `${padZero(date.getDate())}-${padZero(
      date.getMonth() + 1
    )}-${date.getFullYear()} ${padZero(date.getHours())}:${padZero(
      date.getMinutes()
    )}`,
    "datetime-ampm": `${padZero(date.getDate())}-${padZero(
      date.getMonth() + 1
    )}-${date.getFullYear()} ${padZero(date.getHours() % 12 || 12)}:${padZero(
      date.getMinutes()
    )} ${date.getHours() >= 12 ? "PM" : "AM"}`,
    "month-day-year": `${padZero(date.getMonth() + 1)}/${padZero(
      date.getDate()
    )}/${date.getFullYear()}`, // Added format
    "day-shortMonth-year-time-utc": `${padZero(date.getUTCDate())}-${
      shortMonths[date.getUTCMonth()]
    }-${date.getUTCFullYear()} ${padZero(date.getUTCHours())}:${padZero(
      date.getUTCMinutes()
    )}:${padZero(date.getUTCSeconds())}`,

    // Date components with consistent naming
    dateNum: date.getDate(),

    // Day of week formats with consistent naming
    day: shortDays[date.getDay()], // Short day name (Mon)
    shortDay: days[date.getDay()].charAt(0), // First letter of day (M)
    fullDay: days[date.getDay()], // Full day name (Monday)

    // Month formats with consistent naming
    month: shortMonths[date.getMonth()], // Short month name (Feb)
    shortMonth: months[date.getMonth()].charAt(0), // First letter of month (F)
    fullMonth: months[date.getMonth()], // Full month name (February)

    // Year formats with consistent naming
    year: String(date.getFullYear()).slice(2), // Short year (25)
    fullYear: date.getFullYear(), // Full year (2025)

    // Combined formats
    monthYear: `${months[date.getMonth()]} ${date.getFullYear()}`,
    shortMonthYear: `${shortMonths[date.getMonth()]} ${date.getFullYear()}`,

    // Days ago number format
    daysAgoNum: (() => {
      const today = new Date();
      const target = new Date(date);

      // Set both dates to midnight for accurate day comparison
      today.setHours(0, 0, 0, 0);
      target.setHours(0, 0, 0, 0);

      const diffTime = today - target;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

      return diffDays; // Returns just the number (positive = past, negative = future, 0 = today)
    })(),

    ////////////////
    timeZone: (() => {
      const options = { timeZone: "Asia/Kolkata", timeZoneName: "short" };
      const parts = new Intl.DateTimeFormat("en-US", options).formatToParts(
        date
      );
      const tzName = parts.find((p) => p.type === "timeZoneName")?.value || "";

      // Replace GMT+5:30 with IST
      return tzAbbreviations["Asia/Kolkata"] || tzName;
    })(),
    ///////////////////////
  };

  return formats[format] || formats["month/day/year"];
};

// export const exactUTCDate = (date, separator = "/") => {
//   console.log("exactUTCDate called",date);
//   const newDate = new Date(date);
//   const isValidDate = !isNaN(newDate.getTime());
//   if (!isValidDate) return "-";
//   const mm = `0${newDate.getUTCMonth() + 1}`.slice(-2); // months are 0-indexed
//   const dd = `0${newDate.getUTCDate()}`.slice(-2);
//   const yyyy = newDate.getUTCFullYear();

//   return `${mm}${separator}${dd}${separator}${yyyy}`;
// };
export const exactUTCDate = (date, separator = "/") => {
  if (!date) return "-";
  const d = typeof date === "string" ? date : date.toISOString();
  const [yyyy, mm, dd] = d.split("T")[0].split("-");

  return `${mm}${separator}${dd}${separator}${yyyy}`;
};


// Usage examples:
/*
const date = "2025-02-10T18:30:00.000Z";

// Basic formats
dateFormator(date, 'full')           // February 10, 2025
dateFormator(date, 'short')          // Feb 10, 2025
dateFormator(date, 'date-month-year')// 10-02-2025
dateFormator(date, 'date/month/year')// 10/02/2025
dateFormator(date, 'year-month-date')// 2025-02-10
dateFormator(date, 'month-date')     // Feb 10
dateFormator(date, 'time')           // 18:30
dateFormator(date, 'datetime')       // 10-02-2025 18:30
dateFormator(date, 'month-day-year') // 02/10/2025
// For just the time with AM/PM
dateFormator(date, 'time-ampm')  // Example: "11:30 AM"
// For date and time with AM/PM
dateFormator(date, 'datetime-ampm')  // Example: "10-02-2025 11:30 AM"

// timeZone like July 31, 2025 02:45 AM EDT
dateFormator(date, 'timeZone')  // Example: "EDT"





// UTC format example
dateFormator("2025-02-18T11:15:05.000Z", "day-shortMonth-year-time-utc") // "18-Feb-2025 11:15:05"

// Component formats with consistent naming
dateFormator(date, 'dateNum')     // 10 (just the date number)
dateFormator(date, 'day')         // Mon (short day name)
dateFormator(date, 'shortDay')    // M (first letter of day)
dateFormator(date, 'fullDay')     // Monday (full day name)
dateFormator(date, 'month')       // Feb (short month name)
dateFormator(date, 'shortMonth')  // F (first letter of month)
dateFormator(date, 'fullMonth')   // February (full month name)
dateFormator(date, 'year')        // 25 (short year)
dateFormator(date, 'fullYear')    // 2025 (full year)

// Combined formats
dateFormator(date, 'monthYear')      // February 2025
dateFormator(date, 'shortMonthYear') // Feb 2025

// Days ago number format - NEW!
dateFormator(new Date().toISOString(), 'daysAgoNum')           // 0 (today)
dateFormator(new Date(Date.now() - 24*60*60*1000), 'daysAgoNum') // 1 (yesterday)
dateFormator(new Date(Date.now() - 5*24*60*60*1000), 'daysAgoNum') // 5 (5 days ago)
dateFormator(new Date(Date.now() + 24*60*60*1000), 'daysAgoNum')   // -1 (tomorrow)
dateFormator(new Date(Date.now() + 3*24*60*60*1000), 'daysAgoNum') // -3 (in 3 days)

// Handling invalid dates
dateFormator(null, 'full')           // "" (empty string)
dateFormator("invalid-date", 'full') // "-" (invalid date indicator)

// Default format (when format not specified or not found)
dateFormator(date)                   // 02/10/2025 (defaults to 'month-day-year')
dateFormator(date, 'nonexistent')    // 02/10/2025 (defaults to 'month-day-year')
*/
